import { render, staticRenderFns } from "./Recover.vue?vue&type=template&id=40a6f52c&scoped=true&"
import script from "./Recover.vue?vue&type=script&lang=js&"
export * from "./Recover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a6f52c",
  null
  
)

export default component.exports